import './index.css';
import { jsx, Fragment } from 'react/jsx-runtime';
import { useRef, useContext, useCallback, useLayoutEffect } from 'react';
import { createPortal } from 'react-dom';
import classnames from 'classnames';
import { TableContext } from './context.js';
import { c as cellStyles } from './cell-Dr-jPjDU.js';
import { s as styles } from './table-CLlr1zNv.js';

const DENSITY_TO_CSS = {
    'extra-small': styles.densityExtraSmall,
    small: styles.densitySmall,
    medium: styles.densityMedium,
    large: styles.densityLarge,
};
const StickyTableHeader = ({ root, divider, density, headerRef, children }) => {
    const ref = useRef(null);
    const { fontLoaded: renderPortal, subscribeResizeHandler, unsubscribeResizeHandler } = useContext(TableContext);
    const calcWidth = useCallback(() => {
        if (ref.current && root && headerRef.current) {
            const columnsHeader = headerRef.current.querySelectorAll('[data-magritte-table-cell]');
            const widths = [];
            [...columnsHeader].forEach((column, index) => {
                widths[index] = column.getBoundingClientRect().width;
            });
            const columns = ref.current.querySelectorAll('[data-magritte-table-cell]');
            [...columns].forEach((column, index) => {
                column.style.setProperty('width', `${widths[index]}px`);
            });
            root.style.setProperty('margin-bottom', `-${headerRef.current.getBoundingClientRect().height}px`);
        }
    }, [headerRef, root]);
    useLayoutEffect(() => {
        if (root && renderPortal) {
            calcWidth();
            subscribeResizeHandler?.(calcWidth, 1);
            return () => unsubscribeResizeHandler?.(calcWidth);
        }
        return void 0;
    }, [root, renderPortal, calcWidth, subscribeResizeHandler, unsubscribeResizeHandler]);
    return (jsx(Fragment, { children: renderPortal &&
            createPortal(jsx("table", { ref: ref, className: classnames(styles.table, cellStyles.duplicateTable), children: jsx("thead", { className: classnames(styles.header, DENSITY_TO_CSS[density], {
                        [styles.withDivider]: !!divider,
                    }), "data-qa": "table-sticky-header", children: children }) }), root) }));
};

export { StickyTableHeader };
//# sourceMappingURL=StickyTableHeader.js.map
